export default "__VITE_ASSET__CqZemwaS__"